/* ==========================================================================
   tierflow-savings.js

   Adds "Save 43%" under the price in the TierFlow widget, worked out from
   the price and crossed-out price TierFlow is showing:

     $34.99  $19.99 / each  SALE
     Save 43%

   (The order and line break come from assets/tierflow-theme.css.)

   It only reads TierFlow's price and compare-at text and adds its own span;
   it changes nothing TierFlow draws. The label hides whenever TierFlow hides
   the crossed-out price, and whenever the saving rounds to under 1%.
   Styled in assets/tierflow-theme.css.
   ========================================================================== */
(function () {
  var parse = function (el) {
    var m = el && (el.textContent || '').replace(/,/g, '').match(/\$?\s*(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : NaN;
  };

  function update(row) {
    var unit = row.querySelector('.tf-price-unit');
    var compare = row.querySelector('.tf-price-compare');
    var label = row.querySelector('.tf-savings-pct');
    if (!compare) return;
    if (!label) {
      label = document.createElement('span');
      label.className = 'tf-savings-pct';
      compare.insertAdjacentElement('afterend', label);
    }
    var u = parse(unit), c = parse(compare);
    var shown = compare.style.display !== 'none' && c > 0 && u > 0 && c > u;
    var pct = shown ? Math.round((c - u) / c * 100) : 0;
    var text = pct >= 1 ? 'Save ' + pct + '%' : '';
    // Only touch the DOM on a real change, so this observer never feeds itself.
    if (label.textContent !== text) label.textContent = text;
    var display = text ? '' : 'none';
    if (label.style.display !== display) label.style.display = display;
  }

  function watch(row) {
    if (row.dataset.tfSavings) return;
    row.dataset.tfSavings = '1';
    new MutationObserver(function () { update(row); }).observe(row, {
      subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style']
    });
    update(row);
  }

  // TierFlow draws its widget after the page loads, so wait for the price row.
  function scan() { document.querySelectorAll('.tf-price-row').forEach(watch); }
  new MutationObserver(scan).observe(document.documentElement, { subtree: true, childList: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
